export const API_URL="https://demo-mariposa.akonde.fr/api/"
//export const API_URL = "http://localhost:2000"
//export const API_URL = "http://77.37.87.49:2000"
//export const API_URL = "http://192.168.1.109:2000"

export const WHATSAPP_NUMBER = "+33782452937"
